import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-coupon',
  templateUrl: 'coupon.component.html',
  styleUrls: ['coupon.component.scss']
})
export class CouponComponent {
  activeNavItem: string = 'details';
  couponId = '0';

  constructor(private route: ActivatedRoute,) { }

  ngOnInit(): void {
    // get the coupon id from the route params
    this.route.params.subscribe(params => {
      this.couponId = params['couponId'];
    });
  }

  setCurrentActiveItem(item: string) {
    this.activeNavItem = item;
  }
}
